<template>
  <div class="landPlan">

    <div class="edit-area">

      <h2 class="normal">描地块</h2>

      <div class="edit-area-content" v-if="landTypeItems[0].length > 0">
        <div v-if="plan_name">地块名称：{{plan_name}}</div>
        <div class="normal">
          <el-button @click="chooseType = []" type="primary">清空</el-button>
        </div>
        <div class="checkboxes">
          <!-- <el-select v-model="chooseType" filterable multiple placeholder="选择或创建标签">
            <el-option v-for="item in landTypeItems" :key="item.num" :label="item.num" :value="item.num">
            </el-option>
          </el-select> -->

          <el-checkbox-group v-model="chooseType">
            <div v-for="(row,index) in landTypeItems" :key="index" class="divid">
              <el-checkbox v-for="item in row" :label="item.num" :key="item.num">{{item.num}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="normal">
          <el-button @click="upToDb" type="primary">上传</el-button>
        </div>

        <div class="normal">
          编号：<input type="text" v-model="defNum">
          性质：<input type="text" v-model="defName">
        </div>
        <div class="normal">
          <el-button @click="addTypeNum" type="primary">添加</el-button>
        </div>
      </div>

    </div>

    <div id="area_container" :style="mapHeight">
      <el-amap class="amap-box" vid="land_map" ref="land_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-polyline editable=false :path="dots" strokeColor="red" strokeWeight=2></el-amap-polyline>
        <el-amap-marker :vid="'lnglat_marker' + index" v-for="(pos,index) in lnglat" :key="'current' + index"
          :position="pos.split('|')" :events="lnglatMarkerEvents" icon="./../../static/images/marker6.png"
          :offset="[-16,-27]" :draggable="true"></el-amap-marker>
        <el-amap-polyline editable=false :path="selectPath" strokeColor="green" strokeWeight=2></el-amap-polyline>
        <el-amap-marker :vid="'select_marker' + index" v-for="(pos,index) in selectDots" :key="'select' + index"
          :position="pos" icon="./../../static/images/marker3.png" :events="selectMarkerEvents" :draggable="true"
          :offset="[-16,-27]" ></el-amap-marker>
        <el-amap-polygon  v-for="(cell, index) in landCells" :vid="'polygon' + index" :key="'polygon' + index"
          :path="cell.path" strokeColor="#cccccc" fillOpacity=0.6 fillColor="#000000" :events="polygonEvents">
        </el-amap-polygon>
          <el-amap-text v-for="(centerItem, index) of centerCoordinate" v-if="centerItem.center && centerItem.center[0] && centerItem.center[1]" :key="index*2"  :position="centerItem.center"  :text-style="{color: 'red'}" :text="centerItem.text"></el-amap-text>


        <el-amap-polygon v-for="(cell, index) in nearCells" :vid="'near' + index" :key="'near' + index"
          :path="cell.path" strokeColor="#cccccc" fillOpacity=0.6 fillColor="#000000" :events="nearEvents">
        </el-amap-polygon>
        <el-amap-marker :vid="'all_marker' + index" v-for="(pos,index) in lnglatList" :key="'history' + index"
          :position="pos.split('|')" :events="allMarkerEvents" :offset="[-10,-30]"></el-amap-marker>
      </el-amap>
    </div>

    <div class="coverMap top1" @click="lnglatToDots">去线</div>
    <div class="coverMap top2" @click="lnglatList = []">去点</div>
    <div class="coverMap top3" :style="{'background-color': isNear ? 'blue' : 'white'}" @click="isNear = !isNear">周边</div>
    <div class="coverMap top4" :style="{'background-color': selecting ? 'blue' : 'white'}" @click="changeSelect">框选</div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();
  export default {
    data() {
      return {
        id: '',

        mapHeight: {},

        zoom: 15,
        center: [120.051238, 30.228232],
        amapManager,
        plugin: [{
          //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],

        dots: [],
        lnglat: [],
        events: {
          'rightclick': (e) => {
            console.log('右点击地图')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            let that = this
            if (that.isNear) {
              that.loadNear(dot.join('|'));
            } else if (that.selecting) {
              that.selectDots.push(dot)
            } else {
              that.dots.push(dot)
              that.lnglat.push(dot.join('|'))
            }
          }
        },
        lnglatMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            that.dots.splice(index, 1)
            that.lnglat.splice(index, 1)
          },
          'click': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            that.dots.push(that.lnglat[index].split('|'))
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.dots.splice(index, 1, dot)
            that.lnglat.splice(index, 1, dot.join('|'))
          }
        },
        selectMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('select_marker', '')
            that.selectDots.splice(index, 1)
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('select_marker', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.selectDots.splice(index, 1, dot)
          }
        },
        allMarkerEvents: {
          'click': (e) => {
            let that = this
            let index = e.target.w.vid.replace('all_marker', '')
            that.dots.push(that.lnglatList[index].split('|'))
            that.lnglat.push(that.lnglatList[index])
          }
        },
        polygonEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('polygon', '')
            console.log(index);
            that.delOneLand(index);
          },
          'click': (e) => {
            let that = this
            let index = e.target.w.vid.replace('polygon', '')
            let path = that.landCells[index].path;
            for (let i = 0, len = path.length - 1; i < len; i++) {
              let str = path[i].lng + '|' + path[i].lat;
              if (!that.lnglatList.includes(str)) {
                that.lnglatList.push(str);
              } else {
                console.log('重复点击');
              }
            }
          }
        },
        nearEvents: {
          'click': (e) => {
            let that = this
            let index = e.target.w.vid.replace('near', '')
            let path = that.nearCells[index].path;
            for (let i = 0, len = path.length - 1; i < len; i++) {
              let str = path[i].lng + '|' + path[i].lat;
              if (!that.lnglatList.includes(str)) {
                that.lnglatList.push(str);
              } else {
                console.log('重复点击');
              }
            }
          }
        },

        landTypeItems: [[]],
        plan_id: '',
        chooseType: [],
        lnglatList: [],
        landCells: [],

        defNum: '',  // 自己添加类别编号
        defName: '', // 自己添加类别名称
        plan_name: '',
        isNear: false,
        nearCells: [],
        cellDB: '',
        backDB: '',
        backid: '',
        selecting: false,
        selectDots: [],
      }
    },
    computed: {
      selectPath() {
        let result = this.selectDots.slice();
        if (result.length > 3) {
          result.push(result[0]);
        }
        return result;
      },
      centerCoordinate(){
        const centerArr= []
        this.landCells.map(obj => {
          console.log('obj',obj);
          const path = obj.path;
          let totalLat = 0;
          let totalLng = 0;

          path.forEach(coord => {
            totalLat += parseFloat(coord[1]);
            totalLng += parseFloat(coord[0]);
          });

          const centerLat = totalLat / path.length;
          const centerLng = totalLng / path.length;
          centerArr.push({
            center:[centerLng,centerLat],
            text:obj.type
          })
          // console.log({
          //   ceter:[centerLng,centerLat],
          //   text:obj.type
          // });
        });
        // console.log('centerArr',centerArr);
        return centerArr
      }
    },
    created() {
      let that = this
      let height = window.innerHeight + 'px';
      console.log(height)
      that.mapHeight.height = height
      document.onkeydown = function(e) {
        let event = window.event;
        if (event.shiftKey === true && event.keyCode === 65) {
          that.upToDb()
        }
        if (event.shiftKey === true && event.keyCode === 68) {
          that.chooseType = []
        }
        if (that.selecting && that.selectDots.length > 3 && event.keyCode === 46) {
          that.toDeleteSelected()
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        delete origin.lnglatMarkerEvents;
        delete origin.selectMarkerEvents;
        delete origin.allMarkerEvents;
        delete origin.polygonEvents;
        delete origin.nearEvents;
        Object.assign(this.$data, origin)
        this.init(true);
      }
      this.$route.meta.isBack=false
    },
    methods: {
      async init(changeCenter) {
        function sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
        let that = this;
        that.landCells = [];
        let city = that.$store.state.Counter.city;
        let cellMap = {
          '杭州': 'LandCellModel',
          '苏州': 'SzLandCellModel',
        }
        that.cellDB = cellMap[city];
        let backMap = {
          '杭州': 'WpBackupModel',
          '苏州': 'SzBackupModel',
        }
        that.backDB = backMap[city];
        let bidMap = {
          '杭州': '2i7i8jcx67q',
          '苏州': '2jzc6nqfjg4',
        }
        that.backid = bidMap[city];
        let obj = that.$route.params
        if (!obj.id) {
          await sleep(1000);
          obj = that.$route.query;
        }
        if (obj.id) {
          that.$axios.get(that.$url_prefix + 'queryAreaPlanDetail', {
            params: {
              id: obj.id
            }
          }).then(function (res) {
            let plan = res.data.data;
            let currentMap = amapManager.getMap();

            let imageLayer = new AMap.ImageLayer({
              url: plan.image,
              bounds: new AMap.Bounds(plan.southwest.split('|'), plan.northeast.split('|')),
              zooms: [12, 25],
              opacity: 1,
              map: currentMap,
              zIndex: 100
            });
            if (changeCenter) {
              that.center = plan.center.split('|');
            }
            that.plan_id = plan.id;
            that.plan_name = plan.name;
            let list = res.data.landList;
            for (let i = 0, len = list.length; i < len; i++) {
              let one = list[i];
              let list2 = one.dots.split('-')
              for (let k = 0; k < list2.length; k++) {
                list2[k] = list2[k].split('|')
              }
              list2.push(list2[0])
              one.path = list2
              delete one.dots;
              delete one.plan_id;
              that.landCells.push(one);
            }
            that.$axios.get(that.$url_prefix + 'queryOneById', {
              params: {
                id: that.backid,
                db: that.backDB
              }
            }).then(function (res) {
              that.landTypeItems = JSON.parse(res.data.data.data);
              console.log('landTypeItems', that.landTypeItems);
            })
          }).catch(function (res) {
            console.log('query fail', res);
            that.$message.error('查询失败, 请检查网络');
          })
        }
      },

      upToDb() {
        let that = this;
        if (!that.plan_id) {
          return;
        }
        if (that.lnglat.length === 0) {
          return;
        }
        if (that.chooseType.length === 0) {
          return;
        }
        let obj = {
          dots: that.lnglat.join('-'),
          plan_id: that.plan_id,
          type: that.chooseType.join('|'),
          square: Math.round(AMap.GeometryUtil.ringArea(that.lnglat.map(x => x.split('|'))))
        }
        let param = {
          'db': that.cellDB,
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('发送返回', res)
          let one = res.data.data;
          let list2 = one.dots.split('-')
          for (let k = 0; k < list2.length; k++) {
            list2[k] = list2[k].split('|')
          }
          list2.push(list2[0])
          one.path = list2
          delete one.dots;
          delete one.plan_id;
          delete one.create_time;
          delete one.update_time;
          that.landCells.push(one);
          that.dots = [];
          that.lnglat = [];
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      delOneLand(index) {
        let that = this;
        let target = that.landCells[index];
        console.log(that.landCells);
        // console.log([this.landCells[index].path[0].lng,this.landCells[index].path[0].lat]);
        if (!target || !target._id || this.selecting) {
          return;
        }
        let tip = `确定要删除此${target.type}地块吗？`;
        that.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$axios.post(that.$url_prefix + 'delete', {
            'db': that.cellDB,
            'items': JSON.stringify([{
              _id: target._id
            }])
          }).then(function (res) {
            console.log('删除地块', res)
            that.init();
          }).catch(function (res) {
            console.log('删除地块失败', res)
          })
        }).catch(() => {
          console.log('取消')
        });
      },

      lnglatToDots() {
        let that = this
        let temp = JSON.parse(JSON.stringify(that.lnglat))
        for (let i = 0; i < temp.length; i++) {
          temp[i] = temp[i].split('|')
        }
        that.dots = temp
      },

      addTypeNum() {
        let that = this;
        let defNum = that.defNum;
        let defName = that.defName;
        if (defNum && defName) {
          let target = JSON.parse(JSON.stringify(that.landTypeItems));
          let big = defNum[0];
          let judge = true;
          for (let i=0; i<target.length; i++) {
            if (target[i][0].num[0] === big) {
              let find = target[i].find(x => {
                return x.num === defNum;
              })
              if (find) {
                that.$message.error('重复添加');
                return;
              }
              target[i].push({
                num: defNum,
                name: defName
              })
              target[i].sort((a,b) => {
                let numa = parseInt(a.num.slice(1)) || 0;
                let numb = parseInt(b.num.slice(1)) || 0;
                return numa - numb;
              })
              judge = false;
              break
            }
          }
          if (judge) {
            target.push([{
              num: defNum,
              name: defName
            }])
          }
          let obbj = {
            id: that.backid,
            data: JSON.stringify(target)
          }
          let param = {
            'db': that.backDB,
            'model': 'edit',
            'item': JSON.stringify(obbj),
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
            that.landTypeItems = target;
            that.$message({
              type: 'success',
              message: '添加成功'
            });
          }).catch(function (res) {
            that.$message.error('添加失败');
          })
        }
      },


      delAllLand() {
        let that = this;
        let list = JSON.parse(JSON.stringify(that.landCells));
        console.log('list', list);
        for (let i=0; i<list.length; i++) {
          delete list[i].path;
          delete list[i].id;
          delete list[i].type;
        }
        that.$axios.post(that.$url_prefix + 'delete', {
          'db': that.cellDB,
          'items': JSON.stringify(list)
        }).then(function (res) {
          console.log('删除fanhui', res)
        }).catch(function (res) {
          console.log('删除地段失败', res)
        })
      },

      loadNear(lnglat) {
        let that = this;
        that.$open();
        that.nearCells = [];
        that.$axios.post(that.$url_prefix + 'getCellsByRadius', {
          lnglat: lnglat
        }).then(res => {
          that.$close();
          let list = res.data.data;
          for (let i = 0, len = list.length; i < len; i++) {
            let one = list[i];
            let list2 = one.dots.split('-')
            for (let k = 0; k < list2.length; k++) {
              list2[k] = list2[k].split('|')
            }
            list2.push(list2[0])
            one.path = list2
            delete one.dots;
            delete one.plan_id;
            that.nearCells.push(one);
          }
        }).catch(err => {
          that.$close();
        })
      },

      toDeleteSelected() {
        let that = this;
        let arr = [];
        for (let i=0; i<that.landCells.length; i++) {
          let dot = [that.landCells[i].path[0].lng, that.landCells[i].path[0].lat];
          if (AMap.GeometryUtil.isPointInRing(dot, that.selectDots)) {
            arr.push({
              _id: that.landCells[i]._id
            });
          }
        }
        if (!arr.length) {
          that.$message.error('没有选中地块');
          return;
        }
        let tip = `确定要删除此范围内的${arr.length}个地块吗？`;
        that.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$axios.post(that.$url_prefix + 'delete', {
            'db': that.cellDB,
            'items': JSON.stringify(arr)
          }).then(function (res) {
            console.log('删除地块', res)
            that.init();
          }).catch(function (res) {
            console.log('删除地块失败', res)
          })
        }).catch(() => {
          console.log('取消')
        });
      },
      changeSelect() {
        this.selecting = !this.selecting
        this.selectDots = [];
      }
      
    }
  }

</script>

<style scoped>
  button {
    outline: none;
  }

  .landPlan {
    display: flex;
    width: 100%;
  }

  .landPlan .edit-area {
    text-align: center;
    width: 30%;
  }

  .landPlan #area_container {
    width: 70%;
    position: fixed;
    top: 0;
    left: 30%;
  }

  #area_container .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  .coverMap {
    height: 50px;
    width: 50px;
    background-color: red;
    position: fixed;
    z-index: 5;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    left: 30%;
    user-select: none;
  }

  .top1 {
    top: 20px;
  }

  .top2 {
    top: 80px;
  }
  .top3 {
    top: 140px;
  }
  .top4 {
    top: 200px;
  }

  .checkboxes {
    display: inline-block;
    text-align: left;
    width: 80%;
  }

  .divid {
    margin-top: 10px;
    border-top: 1px solid #cccccc;
  }

</style>



// WEBPACK FOOTER //
// src/page/DrawLand.vue